import { Link } from "react-router-dom";

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <section className="mt-8">
    <h2 className="text-xl font-bold text-neutral-900">{title}</h2>
    <div className="mt-3 space-y-3 text-[15px] leading-7 text-neutral-700">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <main className="min-h-screen bg-neutral-50 px-5 py-10 text-neutral-900 md:px-8">
      <article className="mx-auto max-w-3xl rounded-3xl border border-neutral-200 bg-white p-6 shadow-sm md:p-10">
        <Link to="/" className="text-sm font-semibold text-blue-600">
          ← Voltar ao Talki
        </Link>
        <h1 className="mt-6 text-3xl font-extrabold tracking-[-0.03em] md:text-4xl">Política de Privacidade</h1>
        <p className="mt-3 text-sm text-neutral-500">Última atualização: 18 de setembro de 2026</p>

        <Section title="Quem somos">
          <p>
            O Talki é um serviço de prática de inglês por voz operado por Talki AI. Esta política explica como
            tratamos dados pessoais no aplicativo Talki e no site hellopeoplebr.com.
          </p>
        </Section>

        <Section title="Dados que tratamos">
          <ul className="list-disc space-y-2 pl-5">
            <li>dados da conta, como nome, endereço de e-mail e identificador do usuário;</li>
            <li>dados de uso, progresso, cenas praticadas, duração das sessões e eventos técnicos;</li>
            <li>áudio enviado durante uma conversa para processamento em tempo real;</li>
            <li>transcrições, pontuações e análises geradas a partir das sessões de prática;</li>
            <li>status da assinatura, sem armazenamento dos dados completos do cartão pelo Talki;</li>
            <li>informações de diagnóstico, desempenho e falhas, quando as ferramentas correspondentes estiverem ativas.</li>
          </ul>
        </Section>

        <Section title="Como usamos os dados">
          <p>Usamos essas informações para autenticar a conta, fornecer as conversas por voz, salvar progresso e histórico, gerar feedback, controlar o acesso aos recursos, prevenir abuso, corrigir falhas e melhorar o serviço.</p>
        </Section>

        <Section title="Microfone, áudio e inteligência artificial">
          <p>
            O acesso ao microfone só ocorre após sua permissão e enquanto você usa uma experiência de voz. O áudio é
            transmitido para processamento da conversa em tempo real. O Talki salva a transcrição e os resultados da
            prática associados à sua conta; o aplicativo não foi projetado para manter uma gravação de áudio da sessão.
          </p>
          <p>
            Áudio, transcrições e contexto da conversa podem ser processados por provedores de infraestrutura e de
            inteligência artificial necessários para entregar o recurso e produzir o feedback.
          </p>
        </Section>

        <Section title="Fornecedores e compartilhamento">
          <p>
            Podemos compartilhar os dados estritamente necessários com fornecedores que sustentam o serviço, incluindo
            hospedagem e banco de dados, processamento de inteligência artificial, monitoramento de erros, análise de uso
            e cobrança. Também poderemos tratar ou divulgar informações quando necessário para cumprir a lei, proteger
            usuários ou defender direitos. Não vendemos dados pessoais.
          </p>
        </Section>

        <Section title="Armazenamento, segurança e transferências">
          <p>
            Aplicamos controles técnicos e organizacionais compatíveis com a natureza do serviço. Alguns fornecedores
            podem processar dados fora do Brasil, sujeitos às proteções contratuais e legais aplicáveis. Mantemos os dados
            enquanto forem necessários para fornecer o serviço, cumprir obrigações legais ou resolver disputas.
          </p>
        </Section>

        <Section title="Seus direitos e exclusão">
          <p>
            Você pode solicitar acesso, correção, portabilidade, informação sobre compartilhamento ou exclusão dos seus
            dados, conforme a legislação aplicável. Para pedir a exclusão da conta e dos dados relacionados, consulte a
            página <Link to="/excluir-conta" className="font-semibold text-blue-600">Excluir conta</Link>.
          </p>
        </Section>

        <Section title="Crianças e adolescentes">
          <p>O Talki não é direcionado a crianças menores de 13 anos. Se você acreditar que uma criança forneceu dados pessoais indevidamente, entre em contato para que possamos analisar e tomar as medidas cabíveis.</p>
        </Section>

        <Section title="Contato">
          <p>
            Dúvidas ou solicitações relacionadas à privacidade podem ser enviadas para{" "}
            <a className="font-semibold text-blue-600" href="mailto:influency.agency.real@gmail.com">
              influency.agency.real@gmail.com
            </a>.
          </p>
        </Section>
      </article>
    </main>
  );
}
